module.exports = __webpack_public_path__ + "static/media/sd.2b25c2f0.svg";